import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPhotobucketComponent } from './simple-icons-photobucket.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPhotobucketComponent ],
    exports:      [ SimpleIconsPhotobucketComponent ],
    bootstrap:    []
})
export class SimpleIconsPhotobucketModule {}
